<div class="container-fluid">
  <div class="row">
    <img
      class="imgBack cursor-pointer"
      (click)="goBack()"
      src="assets/img/backbtn.png"
    />
  </div>

  <div class="col-md-12">
    <h1 class="title">Fitness Plan Templates</h1>
  </div>

  <hr class="mt-2" />

  <div class="col-md-12 mt-5">
    <!-- Tab Navigation -->
    <div class="tab-navigation">
      <button
        class="tab-btn"
        [class.active]="activeTab === 'new'"
        (click)="setActiveTab('new')"
      >
        New Template
      </button>
      <button
        class="tab-btn"
        [class.active]="activeTab === 'view'"
        (click)="setActiveTab('view')"
      >
        View All Templates
      </button>
    </div>

    <!-- Content Area -->
    <div class="content-area">
      <!-- New Template Tab Content -->
      <div *ngIf="activeTab === 'new'" class="tab-content">
        <div class="new-template-content">
          <!-- Embed the Create Template Component -->
          <app-create-template
            [isEmbedded]="true"
            (templateCreated)="onTemplateCreated()"
          >
          </app-create-template>
        </div>
      </div>

      <!-- View All Templates Tab Content -->
      <div *ngIf="activeTab === 'view'" class="tab-content">
        <div class="view-templates-content">
          <!-- Search Bar -->
          <div class="search-section">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Search templates...</mat-label>
              <input
                matInput
                [(ngModel)]="searchTerm"
                (input)="searchTemplates()"
                placeholder="Search by name or description"
              />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <button
              *ngIf="searchTerm"
              mat-button
              (click)="clearSearch()"
              class="clear-search-btn"
            >
              <mat-icon>clear</mat-icon>
              Clear
            </button>
          </div>

          <!-- Loading Spinner -->
          <div *ngIf="isLoading" class="loading-container">
            <mat-icon class="spin">refresh</mat-icon>
            <p>Loading templates...</p>
          </div>

          <!-- Templates List -->
          <div
            *ngIf="!isLoading && filteredTemplates.length > 0"
            class="templates-list"
          >
            <div class="list-header">
              <div class="header-name">Template Name</div>
              <div class="header-description">Description</div>
              <div class="header-actions">Actions</div>
            </div>

            <div
              *ngFor="let template of filteredTemplates"
              class="template-list-item"
            >
              <div class="item-name">
                <strong>{{ template.name }}</strong>
              </div>
              <div class="item-description">
                <span>{{ template.description || "No description" }}</span>
                <div class="item-meta">
                  <small>
                    {{ template.totalExercises || 0 }} exercise{{
                      template.totalExercises !== 1 ? "s" : ""
                    }}
                    <span
                      *ngIf="!template.isComplete"
                      [class]="getStatusClass(template)"
                    >
                      • {{ getTemplateStatus(template) }}</span
                    >
                    • Created {{ template.createdDate | date : "MMMM d, y, h:mm a" }}
                  </small>
                </div>
              </div>
              <div class="item-actions">
                <button
                  mat-button
                  (click)="viewTemplate(template)"
                  class="list-action-btn view-btn"
                >
                  <mat-icon>visibility</mat-icon>
                  View
                </button>
                <button
                  mat-button
                  (click)="editTemplate(template)"
                  class="list-action-btn edit-btn"
                >
                  <mat-icon>edit</mat-icon>
                  Edit
                </button>
              </div>
            </div>
          </div>

          <!-- No Templates Message -->
          <div
            *ngIf="!isLoading && filteredTemplates.length === 0"
            class="no-templates"
          >
            <mat-icon class="placeholder-icon">list_alt</mat-icon>
            <h3>
              {{ searchTerm ? "No templates found" : "No templates available" }}
            </h3>
            <p>
              {{
                searchTerm
                  ? "Try adjusting your search terms."
                  : "Create your first fitness plan template to get started."
              }}
            </p>
            <button
              *ngIf="!searchTerm"
              class="action-btn primary"
              (click)="createNewTemplate()"
            >
              <mat-icon>add</mat-icon>
              Create First Template
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
